import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import { withRouter } from 'react-router'
import { injectIntl, defineMessages } from 'react-intl'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import subjectsMessages from '../../common/translations/subjectsMessages'
import { withNameInput, Checkbox, PageHeader, ExerciseTestForm,
  Popup, Button, TextInput, SelectInput, Tag } from '../components'
import { SearchPage } from '../pages'
import { fields } from '../../common/lib/redux-fields'
import { loadLessons, setCurrentLesson, clearLessonDetail } from '../../common/lessons/actions'
import { updateMe } from '../../common/users/actions'
import { loadTestDetail } from '../../common/tests/actions'
import { loadTagsBySubject } from '../../common/tags/actions'
import { loadSubjects } from '../../common/subjects/actions'
import { validateCreateTest } from '../../common/tests/validations'
import formValidation from '../../common/lib/formValidation'

class TestForm extends React.Component {
  constructor(props) {
    super(props)
    this.submitForm = this.submitForm.bind(this)

    this.state = {
      visibleexerciseForm: false,
    }
  }

  componentDidMount() {
    const { match, fields, test, lessons, viewer, loadLessons, loadSubjects } = this.props
    const { params } = match
    
    loadSubjects()

    if (!lessons.size && viewer) {
      loadLessons()
    }

    if (!test && match && params && params.id) {
      /* make for multiple lessons */
      fields.$setValue('lessons', [match.params.id])
    }
  }

  componentWillReceiveProps(nextProps) {
    const { subjects } = nextProps
    const prevSubjects = this.props.subjects

    if (!prevSubjects.length && subjects && subjects.length) {
      const englishSubject = subjects.find(s => s.name === 'english')

      this.subjectChange(englishSubject.id)
    }
  }

  componentWillUnmount() {
    const { fields } = this.props
    fields.$reset()
  }

  async submitForm(e) {
    e.preventDefault()
    const { fields, submit, history, test, viewer } = this.props
    const values = {
      ...fields.$values(),
    }

    if (test) values.id = test.id

    if (await submit(values) !== false) {
      fields.$reset()
      if (!viewer) {
        history.push('/sign-up-form')
      } else {
        history.push('/app/tests')
      }
    }
  }

  subjectChange(value) {
    const { fields, loadTagsBySubject } = this.props
    fields.subject.onChange({ value })
    loadTagsBySubject(value)
  }

  showLessonForm(lesson = null) {
    if (lesson) {
      this.props.setCurrentLesson(lesson)
    }
    this.setState({ visibleexerciseForm: true })
  }

  hideLessonForm() {
    const { clearLessonDetail, test, loadTestDetail } = this.props
    clearLessonDetail()
    this.setState({ visibleexerciseForm: false })
    if (test) {
      loadTestDetail(test.id)
    }
  }

  render() {
    const { lessons, subjects, fields, test, viewer, updateMe, intl, isOnboarding } = this.props
    if (!lessons) return null
    let exercises = lessons.toJS()

    if (test) {
      const exercisesIds = exercises.map(e => e.id)
      const filteredTests = test.lessons
        .filter(l => !exercisesIds.includes(l.id))
        .map(l => ({ ...l, inTest: true }))
      exercises = [...exercises, ...filteredTests]
    }

    const selectedSubject = subjects.find(s => s.id === fields.subject.value)

    return (
      <div className="test-page float-left width-full">
        {
          viewer && !viewer.seenGuides.testDescription &&
          <Popup
            title={intl.formatMessage(messages.popupTitle)}
            text={intl.formatMessage(messages.popupContent)}
            onClick={() => updateMe({ seenGuides: { testDescription: true } })}
          />
        }
        <form className="flex-column">
          {/* HEADER + SAVE BUTTON */}
          <PageHeader
            title={test ? `${intl.formatMessage(messages.editTest)} ${test.name}` : intl.formatMessage(messages.createTest)}
            button={
              <Button
                positive
                className="float-right disable-spacing-right"
                onClick={(e) => this.submitForm(e)}
              >
                {intl.formatMessage(messages.saveTest)}
              </Button>
            }
          />
          {this.props.errorMessage}
          {/* TEST NAME */}
          <TextInput
            label={intl.formatMessage(messages.name)}
            placeholder={intl.formatMessage(messages.enterName)}
            {...fields.name}
          />
          <SelectInput
            {...fields.subject}
            label={intl.formatMessage(messages.subject)}
            defaultValue={intl.formatMessage(messages.subjectLabel)}
            options={subjects.map(subject => ({
              ...subject,
              label: intl.formatMessage(subjectsMessages[subject.name]),
            }))}
            onChange={(e) => this.subjectChange(e.target.value)}
          />
          {/* EXERCISE PICKER */}
          <div className="row">
            <h3 className="spacing-top">
              {intl.formatMessage(messages.savedexercises)}:
            </h3>
            <Button
              className="lesson-create"
              onClick={() => this.showLessonForm()}
            >
              {intl.formatMessage(messages.addexercise)}
            </Button>
          </div>
          <div className="row">
            <div className="exercises-picker">
              {
                exercises.length ?
                  <div className="available-exercises-list">
                    {
                      exercises.map(item => (
                        <div
                          key={item.id}
                          className={`item-box horizontal-padding ${fields.lessons.value.includes(item.id) ? 'selected-exercise' : ''}`}
                        >
                          <Checkbox
                            name={item.name}
                            value={item.id}
                            id={item.id}
                            checked={fields.lessons.value.includes(item.id)}
                            className="spacing-right"
                            onChange={() => {
                              let newValue
                              if (!fields.lessons.value.includes(item.id)) {
                                newValue = [...fields.lessons.value, item.id]
                              } else {
                                newValue = fields.lessons.value
                                  .filter(l => l !== item.id)
                              }
                              fields.lessons.onChange({ value: newValue })
                            }}
                            label={<span className="lesson-label">
                              <img className="lesson-icon" src={`/assets/icons/${item.type}.png`} alt="Lesson" />
                              {item.name}
                            </span>}
                          />
                          <div className="spacing-left">
                            {item.tags.map(t => <Tag key={t.id} tag={t} />)}
                          </div>
                        </div>
                      ))
                    }
                  </div>
                :
                  null
                  /*
                  <div className="test-no-exercises float-left width-full item-box column-direction">
                    <p>{intl.formatMessage(messages.noexercises)}</p>
                    <Button
                      onClick={() => this.showLessonForm()}
                    >
                      {intl.formatMessage(messages.addexercise)}
                    </Button>
                  </div>
                  */
              }
            </div>
          </div>
          {/*
            selectedSubject && selectedSubject.isForeignLanguage &&
            <div className="popup-wrapper">
              <div className="popup-content">
                <div className="row">
                  <SearchPage isOnboarding={isOnboarding} />
                </div>
              </div>
            </div>
          */}
          {/* SAVE BUTTON */}
          <div className="block-center bottom-save-button">
            <Button
              big
              positive
              onClick={(e) => this.submitForm(e)}
            >
              {intl.formatMessage(messages.saveTest)}
            </Button>
          </div>
        </form>
        {/* EXERCISE FORM */}
        {
          this.state.visibleexerciseForm &&
          <ExerciseTestForm hide={() => this.hideLessonForm()} />
        }
      </div>
    )
  }
}

TestForm.defaultProps = {
  lessons: null,
  match: null,
  test: null,
  viewer: null,
  subjects: [],
}

TestForm.propTypes = {
  intl: PropTypes.object.isRequired,
  fields: PropTypes.object.isRequired,
  viewer: PropTypes.object,
  test: PropTypes.object,
  match: PropTypes.object,
  lessons: PropTypes.object,
  subjects: PropTypes.array,
  loadTestDetail: PropTypes.func.isRequired,
  clearLessonDetail: PropTypes.func.isRequired,
  setCurrentLesson: PropTypes.func.isRequired,
  updateMe: PropTypes.func.isRequired,
  submit: PropTypes.func.isRequired,
  loadLessons: PropTypes.func.isRequired,
  loadSubjects: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired,
  errorMessage: PropTypes.any.isRequired,
}

TestForm = withRouter(TestForm)

const enhance = compose(
  withNameInput,
  formValidation(props => ({
    validationFunc: validateCreateTest,
    submitFunc: props.submitTest,
  })),
  connect(state => ({
    lessons: state.lessons.all,
    subjects: state.subjects.all,
    viewer: state.users.viewer,
  }), { loadLessons, loadTagsBySubject, loadSubjects, setCurrentLesson, updateMe, clearLessonDetail, loadTestDetail }),
  fields({
    path: 'TestForm',
    fields: [
      'name',
      'lessons',
      'isPublic',
      'subject',
    ],
    getInitialState: props => ({
      name: (props.test && props.test.name) || props.name || '',
      lessons: ((props.test && props.test.lessons) ? [...props.test.lessons.map(l => l.id)] : []),
      isPublic: !!(props.test && props.test.isPublic),
      subject: (props.test && props.test.subject) || '',
    }),
  }),
  injectIntl,
)

export default enhance(TestForm)

const messages = defineMessages({
  popupTitle: {
    id: 'test.form.popupTitle',
    defaultMessage: 'Inštrukcie',
  },
  popupContent: {
    id: 'test.form.popupContent',
    defaultMessage: 'Testy sa skladajú z cvičení, ktoré môžete použiť vo viacerých testoch naraz.',
  },
  editTest: {
    id: 'test.form.editTest',
    defaultMessage: 'Upraviť test',
  },
  createTest: {
    id: 'test.form.createTest',
    defaultMessage: 'Vytvoriť test',
  },
  saveTest: {
    id: 'test.form.saveTest',
    defaultMessage: 'Uložiť test',
  },
  name: {
    id: 'test.form.name',
    defaultMessage: 'Názov',
  },
  enterName: {
    id: 'test.form.enterName',
    defaultMessage: 'Zadajte názov',
  },
  selectedexercises: {
    id: 'test.form.selectedexercises',
    defaultMessage: 'Vybrané cvičenia do testu',
  },
  selectexercise: {
    id: 'test.form.selectexercise',
    defaultMessage: 'Vyberte aspon jedno cvičenie zo zoznamu uložených cvičení.',
  },
  savedexercises: {
    id: 'test.form.savedexercises',
    defaultMessage: 'Vaše uložené cvičenia',
  },
  previouseexercises: {
    id: 'test.form.previouseexercises',
    defaultMessage: 'cvičenie v pôvodnom teste',
  },
  addexercise: {
    id: 'test.form.addexercise',
    defaultMessage: 'Vytvoriť nové cvičenie',
  },
  noexercises: {
    id: 'test.form.noexercises',
    defaultMessage: 'Zatiaľ nemáte žiadne cvičenia. Vyhľadajte a uložte cvičenie pre test.',
  },
  subject: {
    id: 'lesson.formHeader.subject',
    defaultMessage: 'Predmet',
  },
  subjectLabel: {
    id: 'lesson.formHeader.subjectLabel',
    defaultMessage: 'Vyberte predmet',
  },
})



// WEBPACK FOOTER //
// ./src/browser/forms/TestForm.js